import { Loader } from "~components/Atoms";
import { useSchools } from "~components/FormFields";
import { SchoolCard } from "~components/Organisms";

export function SchoolsPage() {
  /*** Queries ***/
  const schools = useSchools();

  /*** Render ***/
  if (!schools) return <Loader />;

  /*** Render #2 ***/
  return (
    <div className="mw-800">
      <ul
        css={{
          display: "flex",
          flexDirection: "column",
          rowGap: 24,
          padding: "0 16px",
          marginTop: 24,
          marginBottom: 24,
        }}
      >
        {schools.map((school, idx) => (
          <SchoolCard school={school} key={idx} />
        ))}
      </ul>
    </div>
  );
}
